import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsString } from 'class-validator';
import { Expose } from 'class-transformer';
import type { ApiServerEntityIDType } from '../../../types';
import { ClientContactType } from '../clientContactType';

export class ClientContactViewModel {
  @ApiProperty()
  @Expose()
  id: ApiServerEntityIDType;

  @ApiProperty()
  @IsNotEmpty()
  @IsString()
  @Expose()
  type: ClientContactType;

  @ApiProperty()
  @IsNotEmpty()
  @IsString()
  @Expose()
  value: string;
}
